import { toValue } from 'vue'

export const NOTE_FIELD_CONFIG = [
  {
    key: 'topInitiatives',
    labelKey: 'onboarding.ai.research_review.initiatives_label',
    placeholderKey: 'onboarding.ai.research_review.initiatives_placeholder'
  },
  {
    key: 'executionBets',
    labelKey: 'onboarding.ai.research_review.execution_bets_label',
    placeholderKey: 'onboarding.ai.research_review.execution_bets_placeholder'
  },
  {
    key: 'keepsUpAtNight',
    labelKey: 'onboarding.ai.research_review.risks_label',
    placeholderKey: 'onboarding.ai.research_review.risks_placeholder'
  }
]

export const createEmptyNoteFields = () => ({
  topInitiatives: '',
  executionBets: '',
  keepsUpAtNight: ''
})

export const getPillarsFilledCount = noteFields => {
  return NOTE_FIELD_CONFIG.filter(field => toValue(noteFields)[field.key]?.trim()).length
}

export const parseCombinedNotes = combinedNotes => {
  const parsed = createEmptyNoteFields()

  if (!combinedNotes?.trim()) {
    return parsed
  }

  const parts = combinedNotes.split('\n\n')

  NOTE_FIELD_CONFIG.forEach(({ key }, index) => {
    if (parts[index] != null) {
      parsed[key] = parts[index].trim()
    }
  })

  return parsed
}

export const combineNoteFields = noteFields => {
  const parts = NOTE_FIELD_CONFIG.map(({ key }) => noteFields[key]?.trim() ?? '')

  if (parts.every(part => !part)) {
    return ''
  }

  return parts.filter(Boolean).join('\n\n')
}
